import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { TelegramOtpSendState } from "./types";

export const telegramOtpSend: Module<TelegramOtpSendState, RootState> = {
  state: {},
  actions,
};
